import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { VideoCategoriesDataService, VideoCategoriesColumnsService } from '../../../services';
import { VideoCategory, VideoCategoriesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-video-category-details',
  templateUrl: './video-category-details.component.html',
  styleUrls: ['./video-category-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class VideoCategoryDetailsComponent implements OnInit, OnDestroy {

  public videoCategory: VideoCategory = {};
  public videoCategories: VideoCategory[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private videoCategoriesDataService: VideoCategoriesDataService,
    private videoCategoriesColumnsService: VideoCategoriesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Video Category - Details');
        this.getVideoCategory(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.videoCategory !== 'undefined') {
      this.videoCategory = this.dynamicDialogConfig.data.videoCategory;
    }
    this.columns = this.videoCategoriesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getVideoCategory(id: number): void {
    this.isLoading = true;
    this.videoCategoriesDataService.getVideoCategory(id).subscribe((response: VideoCategory|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.videoCategory = response;
      }
    });
  }

  list() {
    this.router.navigate(['/video-categories']);
  }

  add() {
    this.router.navigate(['/video-categories/add']);
  }

  edit() {
    this.router.navigate(['/video-categories/edit/' + this.videoCategory.id]);
  }

}
@Component({
  selector: 'app-video-category-details',
  templateUrl: './video-category-details.component.html',
  styleUrls: ['./video-category-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogVideoCategoryDetailsComponent extends VideoCategoryDetailsComponent {
}

